import React from "react";
import { RaisedButton } from "material-ui";
import chunk from "lodash/chunk";
import pickBy from "lodash/pickBy";

import { formatPrice } from "../util";
import config from "../config";

import UserTable from "./partials/user-table.jsx";
import InlineNoticeLabel from "./partials/inline-notice-label.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import UserActions from "../actions/UserActions";
import UserStore from "../stores/UserStore";
import { NewUserTable } from "./partials/new-user-table.jsx";

class Users extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static getStores() {
    return [UserStore];
  }

  static getPropsFromStores() {
    let state = UserStore.getState();
    return state;
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {
      section: {
        marginTop: 20
      }
    };
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {}

  render() {
    let styles = this.getStyles();

    if (
      this.props.paginatedContentCreators.length === 0 ||
      this.props.paginatedUsers.length === 0
    ) {
      return <WorkingIndicator fullPage={true} />;
    }

    let {
      activeGodUser,
      paginatedUsers,
      paginatedContentCreators,
      loadingUsers,
      loadingContentCreators
    } = this.props;

    return (
      <div>
        {this.props.children /* modal */}
        <h1>
          Master Plan <InlineNoticeLabel label="For God's Eyes Only" />
        </h1>
        <div style={styles.section}>
          <h2>Quick actions</h2>
          <RaisedButton
            primary={true}
            onTouchTap={() => this.context.router.push("/god/auto_create")}
            label="Auto-create user"
          />
        </div>
        <div style={styles.section}>
          <h2>Organizations</h2>
          <NewUserTable
            users={paginatedUsers.users}
            pages={paginatedUsers.pages}
            currentUser={activeGodUser}
            loading={loadingUsers}
            onFetchData={(page, sorted, searchTerm) => {
              UserActions.fetchPaginatedUsers({
                page,
                isContentCreators: false,
                sorted,
                searchTerm
              });
            }}
          />
        </div>
        <div style={styles.section}>
          <h2>Content Creators</h2>
          <NewUserTable
            users={paginatedContentCreators.users}
            pages={paginatedContentCreators.pages}
            currentUser={activeGodUser}
            loading={loadingContentCreators}
            onFetchData={(page, sorted, searchTerm) => {
              UserActions.fetchPaginatedUsers({
                page,
                isContentCreators: true,
                sorted,
                searchTerm
              });
            }}
            hideAddButton
          />
        </div>
      </div>
    );
  }
}

export default connectToStores(Users);



// WEBPACK FOOTER //
// ./src/app/components/god-users.jsx